module.exports = __webpack_public_path__ + "img/svg - middle girl.e1ada713.svg";